// extracted by mini-css-extract-plugin
export var progressBar = "_mg-0";
export var progressBarInner = "_mg-1";